<template>
  <div class="orders-page">
    <div class="page-header">
      <h2>订单管理</h2>
      <div class="header-actions">
        <el-select v-model="statusFilter" placeholder="状态筛选" class="filter-select">
          <el-option label="全部" value=""></el-option>
          <el-option label="待付款" value="pending"></el-option>
          <el-option label="已付款" value="paid"></el-option>
          <el-option label="已完成" value="completed"></el-option>
          <el-option label="已取消" value="cancelled"></el-option>
        </el-select>
        <el-input 
          placeholder="搜索订单号..." 
          v-model="searchText" 
          class="search-input"
          prefix-icon="el-icon-search"
        ></el-input>
      </div>
    </div>
    <el-card class="orders-card">
      <el-table :data="orders" border>
        <el-table-column prop="orderNo" label="订单号"></el-table-column>
        <el-table-column prop="routeName" label="线路名称"></el-table-column>
        <el-table-column prop="customerName" label="客户姓名"></el-table-column>
        <el-table-column prop="phone" label="联系电话"></el-table-column>
        <el-table-column prop="price" label="订单金额"></el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <span :class="['status-tag', scope.row.status]">{{ scope.row.statusText }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="下单时间"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" @click="viewOrder(scope.row)">详情</el-button>
            <el-button size="mini" type="success" v-if="scope.row.status === 'pending'" @click="confirmOrder(scope.row)">确认付款</el-button>
            <el-button size="mini" type="danger" @click="cancelOrder(scope.row)">取消订单</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="56">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'Orders',
  data () {
    return {
      searchText: '',
      statusFilter: '',
      currentPage: 1,
      pageSize: 10,
      orders: [
        {
          id: 1,
          orderNo: 'ORD-20250501001',
          routeName: '【云海之巅】武功山3日穿越',
          customerName: '李明',
          phone: '138****8888',
          price: '¥1,280',
          status: 'paid',
          statusText: '已付款',
          createTime: '2025-05-01 10:30:25'
        },
        {
          id: 2,
          orderNo: 'ORD-20250502002',
          routeName: '【贡嘎圣境】梅里雪山滇藏朝圣',
          customerName: '王芳',
          phone: '139****6666',
          price: '¥4,800',
          status: 'pending',
          statusText: '待付款',
          createTime: '2025-05-02 14:20:18'
        },
        {
          id: 3,
          orderNo: 'ORD-20250503003',
          routeName: '【简单穿越】秦岭西梁入门行',
          customerName: '张伟',
          phone: '137****5555',
          price: '¥199',
          status: 'completed',
          statusText: '已完成',
          createTime: '2025-05-03 09:15:42'
        },
        {
          id: 4,
          orderNo: 'ORD-20250504004',
          routeName: '【四姑娘山】二峰冲顶挑战',
          customerName: '刘洋',
          phone: '136****4444',
          price: '¥3,680',
          status: 'paid',
          statusText: '已付款',
          createTime: '2025-05-04 16:45:33'
        },
        {
          id: 5,
          orderNo: 'ORD-20250505005',
          routeName: '【死亡谷】祁连山深度徒步',
          customerName: '陈静',
          phone: '135****3333',
          price: '¥7,500',
          status: 'cancelled',
          statusText: '已取消',
          createTime: '2025-05-05 11:00:55'
        }
      ]
    }
  },
  methods: {
    handleSizeChange (val) {
      this.pageSize = val
    },
    handleCurrentChange (val) {
      this.currentPage = val
    },
    viewOrder (order) {
      this.$message.info(`查看订单: ${order.orderNo}`)
    },
    confirmOrder (order) {
      this.$confirm('确认该订单已付款?', '提示', {
        type: 'success'
      }).then(() => {
        this.$message.success('订单已确认')
      }).catch(() => {
        this.$message.info('已取消')
      })
    },
    cancelOrder (order) {
      this.$confirm('确定要取消该订单吗?', '提示', {
        type: 'warning'
      }).then(() => {
        this.$message.success('订单已取消')
      }).catch(() => {
        this.$message.info('已取消操作')
      })
    }
  }
}
</script>

<style scoped>
.orders-page {
  padding: 24px;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.page-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.filter-select {
  width: 140px;
}

.search-input {
  width: 280px;
}

.orders-card {
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.status-tag {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.status-tag.pending {
  background-color: #fef3c7;
  color: #d97706;
}

.status-tag.paid {
  background-color: #dbeafe;
  color: #2563eb;
}

.status-tag.completed {
  background-color: #dcfce7;
  color: #16a34a;
}

.status-tag.cancelled {
  background-color: #f3f4f6;
  color: #6b7280;
}
</style>
